import TECH_COLORS from "../constants/techColors"

export function TechStack({ stack }) {
    const [color, backgroundColor] = TECH_COLORS[stack] || ["white", "black"];
    return (
        <span key={stack} className="stack" style={{ color, backgroundColor }}>
            {stack}
        </span>
    )
}